import React from "react";
import { OptionTypeItem } from "./styles";

const OptionTypeTransactionItem = ({ checked, value, label, onChange }) => {
  const onClick = () => {
    onChange(value, !checked);
  };
  return (
    <OptionTypeItem className={checked && "checked"} onClick={onClick}>
      {label}
    </OptionTypeItem>
  );
};

export default OptionTypeTransactionItem;
